import { Component, TemplateRef, ViewChild } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LocalStorageService } from 'src/app/shared/service/storage/localstorage.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import * as FileSaver from 'file-saver';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { FecthDataService } from 'src/app/shared/service/fetchservice/fetchservice';
import { ParameterService } from 'src/app/shared/service/params/param';
import { AuthService } from 'src/app/shared/service/auth/auth.service';
import { AddParametrageProduitsComponent } from '../add-parametrage-produits/add-parametrage-produits.component';
import { EditParametrageProduitsComponent } from '../edit-parametrage-produits/edit-parametrage-produits.component';

@Component({
  selector: 'app-parametrage-produits',
  templateUrl: './parametrage-produits.component.html',
  styleUrl: './parametrage-produits.component.scss'
})

export class ParametrageProduitsComponent {

  items: any = [];
  user_reference: any;
  paginatedItems = [];
  first: number = 0;
  rows: number = 10;
  totalRecords: number = 0;
  isLoading: boolean = false;
  searchTerm: string;
  filteredtems: any = [];
  searchDate: string = '';
  dateDebut: string = '';
  dateFin: string = '';
  searchGender: string = '';
  statut: any = '';
  isDisabled: boolean = false;
  hasError = false;
  errorMessage = '';
  @ViewChild('modalContent') modalContent: TemplateRef<any>;


  constructor(

    private modalService: NgbModal,
    private localstorage: LocalStorageService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private ngxService: NgxUiLoaderService,
    private router: RouterModule,
    private FecthDataService: FecthDataService,
    private paramService: ParameterService,
    private authService: AuthService


  ) {
    this.FecthDataService.actionCreated$.subscribe(() => {
      // Met à jour la liste après la création réussie d'un glossaire
      this.getParametrageProduit();
    });
  }

  ngOnInit() {
     this.user_reference = this.localstorage.getUsers().data.reference;
    // console.log("this.user_reference", this.user_reference);
  }


  getParametrageProduit() {
    this.isLoading = true;
    this.hasError = false;

    this.paramService.getParametrageProduit().subscribe(
      (response: any) => {
        this.isLoading = false;
        this.items = response.data;
        this.filteredtems = this.items;
        this.totalRecords = this.items.length; // Met à jour le total des enregistrements
        this.updatePaginated();

        //console.log("la reponse du webservice", this.items);

      },
      (error) => {
        //console.log("une erreu est survenu", error);
        this.isLoading = false;
        this.hasError = true;
        this.errorMessage = 'Impossible de charger les données';
      }
    )
  }
  onPageChange(event) {
    this.first = event.first; // Mise à jour de la page actuelle
    this.rows = event.rows; // Mise à jour de la page actuelle
    this.updatePaginated();
  }

  // Méthode pour mettre à jour les données paginées des projets
  updatePaginated() {
    const start = this.first;
    const end = start + this.rows;
    this.paginatedItems = this.filteredtems.slice(start, end);
  }
  openModal() {
    this.modalService.open(AddParametrageProduitsComponent, {
      centered: true,
      backdrop: 'static',
      size: 'xl'
    });
  }

  editOpenModal(item: any) {
    this.localstorage.saveProduit(item);
    this.modalService.open(EditParametrageProduitsComponent, {
      centered: true,
      backdrop: 'static',
      size: 'xl'
    });
  }

  confirmSuppression(event: any) {
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: 'Êtes-vous sûr de vouloir supprimer ce produit?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: 'pi pi-check',
      rejectIcon: 'pi pi-times',
      acceptButtonStyleClass: 'p-button-danger', // Style pour le bouton "Oui" (rouge)
      rejectButtonStyleClass: 'p-button-text p-button-primary', // Style pour le bouton "Non" (bleu)
      acceptLabel: 'Oui',
      rejectLabel: 'Non',
      accept: () => {
        this.ngxService.start();
          const requestData={
              produit_id:event.reference,
              user_id:this.user_reference 
            }
        this.paramService.deleteProduit(requestData).subscribe(

          (response: any) => {

            // console.log("la reponse du webserice",response);
            this.messageService.add({ severity: 'success', summary: "AfriCereal", detail: response.message });

            this.getParametrageProduit();
            this.ngxService.stop();

          },
          (error) => {
            this.ngxService.stop();

            // console.log("une erreur est survenu",error);
            this.messageService.add({ severity: 'error', summary: "AfriCereal", detail: error });


          },
        )
      },
      // reject: () => {
      //     this.messageService.add({ severity: 'warn', summary: Constant.rechercheiTitle, detail: 'Vous avez rejeté', life: 3000 });
      // }
    });
  }
}